module.exports = __webpack_public_path__ + "static/media/codesandbox.90002c31.svg";